/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ach/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Ach({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/AutopaymentSetup/Pay/ChooseType/Ach"
  
}) {
let payersActivetabInstallmentMetadataTypeValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'activeTab.installment_metadata.type',
})
let constantData = 'ach'
let aggregateData = fromAggregate.equals(payersActivetabInstallmentMetadataTypeValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Ach.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="payers.activeTab.installment_metadata.type"
 data="'ach'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 paddingRight={0}
 marginRight={0}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={0}
 text="Bank account (ACH)"
/>
</div>
{children}
</React.Fragment>)
}